import { init, Payment } from '@airwallex/components-sdk';
import { Injectable } from '@angular/core';
import { LanguageCode } from './airwallex.dtos';
import { Observable } from 'rxjs';
import { ClientAppSecretForCaptain } from '../common/dtos/captain-client-app-secret.dto';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AirwallexService {
  constructor(private http: HttpClient) {}

  async initAirwallex() {
    await init({
      env: environment.airwallexEnv,
      locale: 'en',
      enabledElements: ['payments'],
    });
  }

  public getAirwallexLanguageCode(languageCode: string): Payment.Locale {
    const validCodes: Payment.Locale[] = [
      'ar',
      'da',
      'de',
      'en',
      'es',
      'fi',
      'fr',
      'id',
      'it',
      'ja',
      'ko',
      'ms',
      'nl',
      'pl',
      'pt',
      'ro',
      'ru',
      'sv',
      'zh',
      'zh-HK',
    ];
    const isLanguageCodeValid = validCodes.includes(
      languageCode as Payment.Locale,
    );
    if (!isLanguageCodeValid) return 'en';
    return languageCode as Payment.Locale;
  }

  getClientSecret(): Observable<ClientAppSecretForCaptain> {
    return this.http.get<ClientAppSecretForCaptain>(
      `${environment.captainApiUrl}/payment-users/app-access-token`,
      {
        withCredentials: true,
      },
    );
  }
}
